import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportSummaryTransactionResellerPage } from './report-summary-transaction-reseller.page';

const routes: Routes = [
  {
    path: '',
    component: ReportSummaryTransactionResellerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportSummaryTransactionResellerPageRoutingModule {}
